import React from "react";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import { Resizable } from "react-resizable";
import styled from "styled-components";
import { CloseButton } from "../styled-components/";
import { TitleBar, Title } from "../styled-components/Popup";

const ResizablePopup = styled(Resizable)`
  position: absolute;
  z-index: 10000;

  > span.react-resizable-handle {
    display: ${props => (props.axis === "none" ? "none" : "block")};
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: -3px;
    right: -3px;
    background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+");
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
    z-index: 100000;
  }
`;

const Container = styled.div`
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  height: ${props => (isNaN(props.height) ? "auto" : `${props.height}px`)};
  min-height: ${props =>
    isNaN(props.minHeight) ? "auto" : `${props.minHeight}px`};
  width: ${props => (isNaN(props.width) ? "auto" : `${props.width}px`)};
  display: ${props => (props.visible ? "flex" : "none")};
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: ${props => props.theme.modal.background}
  align-items: center;
  justify-content: center;
  align-content: center;
`;

const InnerContainer = styled.div`
  border: 1px solid ${props => props.theme.border};
  height: ${props => `${props.height}px`};
  min-height: ${props => (props.minHeight ? `${props.minHeight}px` : "0")};
  width: ${props => `${props.width}px`};
  display: flex;
  flex-direction: column;
`;

const TopBarContainer = styled.div`
  width: 100%;
`;

const TopBarComponent = styled.div``;

class DraggablePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: props.height,
      width: props.width
    };
  }

  onResize = (event, { size }) => {
    this.setState({
      width: size.width,
      height: size.height
    });
  };

  render() {
    const {
      children,
      minHeight,
      visible,
      title,
      closeDialog,
      resizable,
      ...other
    } = this.props;
    return (
      <Draggable {...other}>
        <ResizablePopup
          axis={resizable ? "both" : "none"}
          height={this.state.height}
          width={this.state.height}
          onResize={this.onResize}
          minConstraints={[400, minHeight]}
        >
          <Container
            height={this.state.height}
            width={this.state.width}
            visible={visible}
          >
            <InnerContainer height={this.state.height} width={this.state.width}>
              <TopBarContainer className="handle">
                <TitleBar>
                  <TopBarComponent>
                    <Title>{title}</Title>
                  </TopBarComponent>
                  <TopBarComponent>
                    <CloseButton onClick={closeDialog}>&times;</CloseButton>
                  </TopBarComponent>
                </TitleBar>
              </TopBarContainer>
              {children}
            </InnerContainer>
          </Container>
        </ResizablePopup>
      </Draggable>
    );
  }
}

DraggablePopup.defaultProps = {
  children: null,
  height: 300,
  minHeight: 300,
  width: 400,
  visible: true,
  closeDialog: () => {},
  title: "",
  resizable: false
};

DraggablePopup.propTypes = {
  resizable: PropTypes.bool,
  children: PropTypes.element,
  title: PropTypes.string,
  closeDialog: PropTypes.func,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool
};

export default DraggablePopup;



// WEBPACK FOOTER //
// ./app/components/DraggablePopup.js